<div class="modal-header">
  <h4 class="modal-title">Permission</h4>
<!--  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">-->
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close('Cross click')">

  </button>
</div>
<div class="modal-body">
  <form [formGroup]="permissionForm" (ngSubmit)="onFormSubmit()" id="ngForm">
    <div class="row">
      <div class="col-md-6">
        <label class="form-label">{{'Name'|translate}} <span class="text-danger">*</span></label>
        <input class="form-control form-control-sm" type="text" placeholder="Ex. Permission" formControlName="name" [ngClass]="{'is-invalid': fc['name'].invalid && isSubmitted}">
        <small class="invalid-feedback fst-italic" *ngIf="fc['name'].errors?.['required']">This field is required</small>
        <div class="invalid-feedback" *ngIf="fc['name'].errors?.['minlength']">Name must be atleast 3 caracters long</div>
        <div class="invalid-feedback" *ngIf="fc['name'].errors?.['serverError']">
          {{ fc['name'].errors?.['serverError'] }}
        </div>
      </div>

            <div class="col-md-6">
                <label class="form-label">{{ 'enable ?'|translate }} <span class="text-danger">*</span></label>
                <div class="btn-radio" >
                    <div class="btn-group" data-bs-toggle="buttons">
                        <div class="btn btn-light txt-dark">
                            <div class="radio radio-dark">
                                <input id="radio21" formControlName="isEnable" type="radio" value='1'>
                                <label for="radio21">{{ 'yes'|translate }}</label>
                            </div>
                        </div>
                        <div class="btn btn-light txt-dark">
                            <div class="radio radio-dark">
                                <input id="radio22" formControlName="isEnable" type="radio" value='0'>
                                <label for="radio22">{{ 'no'|translate }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>

  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>


  <button form="ngForm" (submit)="onFormSubmit()" type="submit" class="btn btn-sm btn-outline-primary" [disabled]=saving>
    <ng-container *ngIf="!saving; else isSaving">{{data ? update : create}}</ng-container>
    <ng-template #isSaving>
      {{ "Submitting" | translate}} ...
    </ng-template>
  </button>

</div>














